import {
  sona,
  nazim,
  joshua,
  allen,
  subramani,
  mrinalini,
  karthik,
} from "../assets/team/index";
const developers = [
  {
    id: 1,
    name: "Sona Martin",
    image: sona,
  },
  {
    id: 2,
    name: "Joshua Joy Reji",
    image: joshua,
  },
  {
    id: 3,
    name: "Nazim Filzer",
    image: nazim,
  },
  {
    id: 4,
    name: "Allen Shibu",
    image: allen,
  },
  {
    id: 5,
    name: "Subramani E",
    image: subramani,
  },
  {
    id: 6,
    name: "Mrinalini Nair",
    image: mrinalini,
  },
  {
    id: 7,
    name: "Karthik G Kumar",
    image: karthik,
  },
];
export default developers;
